module.exports = __webpack_public_path__ + "static/media/parking.778cd216.png";